<div class="comments-page">
  <nav class="comments-navbar mobile-view">
    <button class="chev" type="button" (click)="goBack()" aria-label="Back">
      <img src="/assets/images/Expand_Chevron.png" class="rot90" alt="Back">
    </button>
    <div class="nav-title">{{ title }}</div>
  </nav>

  <div class="history-content">
    <div class="history-desktop-header desktop-view">
      <button class="desktop-close-button" type="button" (click)="onClose()" aria-label="Close">
        <span>&times;</span>
      </button>
      <h1 class="desktop-history-title">{{ title }}</h1>
    </div>

    <div class="history-scroll-area">
      <!-- Shared template for persona header content -->
      <ng-template #personaHeaderContent>
        <div class="card-line2">
          <img class="meta-icon" src="/assets/images/Plant_Variety.png" alt="Variety">
          <span class="meta-text variety">{{ headerVariety }}</span>
          <span class="meta-sep" aria-hidden="true"></span>
          <img class="meta-icon" src="/assets/images/Truck.png" alt="Haulier">
          <span class="meta-text haulier">{{ headerHaulier }}</span>
        </div>
      </ng-template>

      <div class="desktop-sticky-wrapper" *ngIf="header">
        <section class="details-card desktop-sticky-card">
          <div class="card-line1">
            <span class="load-number">{{ headerLoadNumber }}</span>
          </div>
          <ng-container *ngTemplateOutlet="personaHeaderContent"></ng-container>
          <div class="card-line3">
            <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
            <span class="sched-label">Scheduled Delivery - </span>
            <span class="sched-value">{{ header.scheduledText || '' }}</span>
          </div>
        </section>
      </div>

      <div class="mobile-sticky-wrapper" *ngIf="header">
        <section class="details-card mobile-details-card">
          <div class="card-line1">
            <span class="load-number">{{ headerLoadNumber }}</span>
          </div>
          <ng-container *ngTemplateOutlet="personaHeaderContent"></ng-container>
          <div class="card-line3">
            <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
            <span class="sched-label">Scheduled Delivery - </span>
            <span class="sched-value">{{ header.scheduledText || '' }}</span>
          </div>
        </section>
      </div>

      <section class="history-section">
    <div *ngIf="isLoading(); else listTpl" class="loading">Loading…</div>
    <ng-template #listTpl>
      <div class="timeline">
        <div class="history-card" *ngFor="let h of filtered()">
          <div class="dot"></div>
          <div class="card">
            <div class="row1">
              <span class="name">{{ h.createdByUsername || 'User' }}</span><span class="persona" *ngIf="h.createdByRoles">, {{ h.createdByRoles }}</span>
            </div>
            <div class="date">{{ h.createdOn | dateWithOrdinal:'EEE, d MMM y, HH:mm' }}</div>
            <!-- Special message for Stage Transitioned action -->
            <div class="changes" *ngIf="h.action === 'Stage Transitioned'">
              <div class="changes-title">Scheduler sent the load back to Transloading for a rewash</div>
            </div>
            <!-- Special message for Passport Rescheduled action -->
            <div class="changes" *ngIf="h.action === 'Passport Rescheduled'">
              <div class="changes-title">Passport was Rescheduled</div>
              <ul class="changes-list" *ngIf="h.details.length > 0">
                <li *ngFor="let detail of h.details">
                  <span class="change-key">{{ detail.fieldName }}</span> - 
                  <span class="change-val">
                    <span class="old-value">"{{ detail.oldValue }}"</span>
                    <span class="arrow"> &rarr; </span>
                    <span class="new-value">"{{ detail.newValue }}"</span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="changes" *ngIf="h.action !== 'Stage Transitioned' && h.action !== 'Passport Rescheduled' && h.details.length > 0">
              <div class="changes-title">Changes :</div>
              <ul class="changes-list">
                <li *ngFor="let detail of h.details">
                  <!-- Special handling for Draft Status -->
                  <ng-container *ngIf="detail.isDraftStatus">
                    <span class="change-key">Saved as Draft</span>
                  </ng-container>
                  <!-- Special handling for Submit Status -->
                  <ng-container *ngIf="detail.isSubmitStatus">
                    <span class="change-key">{{ detail.fieldName }}</span> - 
                    <span class="change-val">
                      <ng-container *ngIf="detail.oldValue">
                        <span class="old-value">"{{ detail.oldValue }}"</span>
                        <span class="arrow"> → </span>
                      </ng-container>
                      <span class="new-value">"{{ detail.newValue }}"</span>
                    </span>
                  </ng-container>
                  <!-- HACCP Image handling -->
                  <ng-container *ngIf="!detail.isDraftStatus && !detail.isSubmitStatus && detail.isHaccpUpload">
                    <span class="change-key">HACCP Image</span> - <span class="change-val">uploaded</span>
                  </ng-container>
                  <!-- Normal field handling -->
                  <ng-container *ngIf="!detail.isDraftStatus && !detail.isSubmitStatus && !detail.isHaccpUpload">
                    <span class="change-key">{{ detail.fieldName }}</span> - 
                    <span class="change-val">
                      <span class="old-value">"{{ detail.oldValue }}"</span>
                      <span class="arrow"> → </span>
                      <span class="new-value">"{{ detail.newValue }}"</span>
                    </span>
                  </ng-container>
                </li>
                <li *ngIf="h.haccpChange && !h.hasHaccpUpload">
                  <span class="change-key">HACCP Image</span> - <span class="change-val">modified</span>
                </li>
              </ul>
            </div>
            <div class="reason" *ngIf="h.reason">
              <span class="reason-key">Reason :</span>
              <span class="reason-val">{{ h.reason }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-state" *ngIf="!isLoading() && filtered().length === 0">
        <div class="empty-circle">
          <img class="empty-icon" src="/assets/images/No_Comments.png" alt="No history">
        </div>
        <div class="empty-title">No History Yet</div>
      </div>
    </ng-template>
    </section>
    </div>
  </div>
</div>



